export default
    {
        path: 'workflowFormOpen', 
        //name: 'WorkflowFormOpen',
        component: () => import('../view/workflow/WorkflowFormOpen.vue'),
        props: (route) => (
            {
                sapId:route.query.sapId,
                processDefinitionId: route.query.processDefinitionId,
                taskId2: route.query.taskId2,
                type: route.query.type,
                token:route.query.token,
                koaToken:route.query.koaToken,
                userId:route.query.userId,
                deviceType:route.query.deviceType,
                deviceName:route.query.deviceName,
                process_instance_id:route.query.process_instance_id,
                noticeId:route.query.noticeId,
                isBl:route.query.isBl,  //是否允许办理 0：不允许 1：允许 默认是1
                secondLoginType:route.query.secondLoginType,
                secondAssessToken:route.query.secondAssessToken,
                deviceId:route.query.deviceId,
                OidcAuthorizationMode:route.query.OidcAuthorizationMode,
                OidcAuthorization:route.query.OidcAuthorizationMode,
                codeType:route.query.st,
                fromSys:route.query.fromSys
            }
        ),
        children: [
            {
                path: "workflowAuditOther",
                //name: "workflowAuditOther",
                component: () => import('../view/workflow/WorkflowAuditOther.vue'),
                props: (route) => (
                    {
                        processDefinitionId: route.query.processDefinitionId,
                        taskId: route.query.taskId,
                        type: route.query.type
                    }
                )
            },
            {
                path: "workfloOpenSubForm",
                //name: "workfloOpenSubForm",
                component: () => import('../view/workflow/WorkflowFormSubOpen.vue'),
                props: (route) => (
                    {
                        processDefinitionId: route.query.processDefinitionId,
                        taskId: route.query.taskId,
                        type: route.query.type,
                        isCreate: JSON.parse(route.query.isCreate),
                        editMode: JSON.parse(route.query.editMode),
                        subTitle: route.query.subTitle,
                        subTableName: route.query.subTableName,
                        subTableAlignFieldName: route.query.subTableAlignFieldName,
                        recordIndex: Number(route.query.recordIndex),
                        OidcAuthorizationMode:route.query.OidcAuthorizationMode,
                        OidcAuthorization:route.query.OidcAuthorizationMode
                    }
                )
            }
        ]

    }



// WEBPACK FOOTER //
// ./src/router/workflowFormRouter.js